export const actionTypes = {
  REQUEST_START: 'PROFILE.ACCOUNTS_ABROAD.REQUEST_START',
  REQUEST_START_SKIP_LOADING: 'PROFILE.ACCOUNTS_ABROAD.REQUEST_START.SKIP_LOADING',
  REQUEST_SUCCESS: 'PROFILE.ACCOUNTS_ABROAD.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'PROFILE.ACCOUNTS_ABROAD.REQUEST_FAILURE',
  SET_TITLE: 'PROFILE.ACCOUNTS_ABROAD.SET_TITLE',
  DELETE: 'PROFILE.ACCOUNTS_ABROAD.DELETE',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function startRequestSkipLoading() {
  return {
    type: actionTypes.REQUEST_START_SKIP_LOADING,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function setTitle(accountId, title) {
  return {
    type: actionTypes.SET_TITLE,
    payload: {
      accountId,
      title,
    },
  };
}

export function deleteAccount(accountId) {
  return {
    type: actionTypes.DELETE,
    payload: {
      accountId,
    },
  };
}
